import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { registerUser } from '../../services/user';
import { showAlert } from '../../store/ducks/alert';

import CloseIcon from '@material-ui/icons/Close';
import { TextField, IconButton, Button } from '@material-ui/core';

const RegisterForm = ({ onOpen }) => {
  const dispatch = useDispatch();
  const [account, setAccount] = useState({
    username: '',
    email: '',
    channelName: '',
    authorName: '',
    description: '',
    slug: '',
  });

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      await registerUser(account);
      dispatch(showAlert('success', 'User has been registered! 🔥'));
      window.location = '/users';
    } catch (e) {
      dispatch(showAlert('error', 'Error! We could not register the user. 😔'));
    }
  };

  return (
    <div className="form-container">
      <div className="container-top">
        <h2>Register User</h2>
        <IconButton onClick={onOpen}>
          <CloseIcon />
        </IconButton>
      </div>
      <form onSubmit={handleSubmit} className="form">
        <div className="form-line">
          <TextField
            className="form-input"
            placeholder="E-mail"
            value={account.email}
            onChange={e => setAccount({ ...account, email: e.target.value })}
          />
          <TextField
            className="form-input"
            placeholder="Author Name"
            value={account.authorName}
            onChange={e => setAccount({ ...account, authorName: e.target.value })}
          />
        </div>
        <div className="form-line">
          <TextField
            className="form-input"
            placeholder="Channel Name"
            value={account.channelName}
            onChange={e => setAccount({ ...account, channelName: e.target.value })}
          />

          <TextField
            className="form-input description"
            placeholder="Channel Slug"
            value={account.slug}
            onChange={e =>
              setAccount({
                ...account,
                slug: e.target.value.toLocaleLowerCase(),
              })
            }
          />
        </div>

        <Button variant="contained" color="primary" className="form-btn" type="submit">
          Register User
        </Button>
      </form>
    </div>
  );
};

export default RegisterForm;
